export default [
  {
    path: '/ui/typography',
    name: 'ui-typography',
    component: () => import('@/views/ui/typography/Typography.vue'),
    meta: {
      pageTitle: 'Typography',
      breadcrumb: [
        {
          text: 'UI',
        },
        {
          text: 'Typography',
          active: true,
        },
      ],
    },
  },
  {
    path: '/ui/colors',
    name: 'ui-colors',
    component: () => import('@/views/ui/colors/Colors.vue'),
    meta: {
      pageTitle: 'Colors',
      breadcrumb: [
        {
          text: 'UI',
        },
        {
          text: 'Colors',
          active: true,
        },
      ],
    },
  },
  {
    path: '/ui/feather',
    name: 'ui-feather',
    component: () => import('@/views/ui/feather/Feather.vue'),
    meta: {
      section:0,
      pageTitle: 'Feather',
      breadcrumb: [
        {
          text: 'UI',
        },
        {
          text: 'Feather',
          active: true,
        },
      ],
    },
  },
  {
    path: '/ui/tabler',
    name: 'ui-tabler',
    component: () => import(/* webpackChunkName: "TablerIcons" */ '@/views/ui/tabler/Tabler.vue'),
    meta: {
      section:0,
      pageTitle: 'Tabler',
      breadcrumb: [
        {
          text: 'UI',
        },
        {
          text: 'Tabler',
          active: true,
        },
      ],
    },
  },
]
